import { gql } from '@apollo/client';

export default gql`
  mutation deleteSpaceUser($id: ID!) {
    deleteSpaceUser(input: { id: $id }) {
      success
    }
  }
`;
